import { inject } from "@angular/core";
import { Router, CanActivateFn } from "@angular/router";
import { map, catchError, of } from "rxjs";
import { TenantService } from "../_services/tenant.service";
import { TokenService } from "../_services/token.service";
import { UserType } from "../_admin/user-managment/models/UserManagementDTO";

export const partnerAdminGuard: CanActivateFn = (route, state) => {
  const tenantService = inject(TenantService);
  const tokenService = inject(TokenService);
  const router = inject(Router);

  return tenantService.GetUserTenants().pipe(
    map((tenants) => {
      const currentTenantName = tokenService.GetTenant();
      const currentTenant = tenants.find((t) => t.name === currentTenantName);

      if (currentTenant?.userType === UserType.PartnerAdmin || currentTenant?.userType === UserType.TenantAdmin) {
        return true;
      }

      localStorage.setItem('redirectUrl', state.url);
      router.navigateByUrl('/');
      return false;
    }),
    catchError(() => {
      localStorage.setItem('redirectUrl', state.url);
      router.navigateByUrl('/');
      return of(false);
    })
  );
};
